import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/pt-br';
import { withTranslation } from 'react-i18next';
import Year from './Year';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const YearCalendar = (props) => {
  const { t, onSelectEvent, calendarDays, onRemoveEvent } = props;

  const localizer = momentLocalizer(moment);
  localizer.formats.yearHeaderFormat = 'YYYY';

  return (
    <BigCalendar
      localizer={localizer}
      toolbar={false}
      messages={{ year: t('general.year') }}
      views={{
        year: Year,
      }}
      date={
        calendarDays && calendarDays.length
          ? new Date(calendarDays[0].dateInMilli)
          : new Date()
      }
      defaultView="year"
      showMultiDayTimes={false}
      onSelectSlot={onSelectEvent}
      daysCalendar={calendarDays}
      onRemoveEvent={onRemoveEvent}
      t={t}
    />
  );
};

YearCalendar.propTypes = {
  t: PropTypes.func.isRequired,
  onSelectEvent: PropTypes.func.isRequired,
  onRemoveEvent: PropTypes.func.isRequired,
  calendarDays: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
};

export default withTranslation('common')(memo(YearCalendar));
